import * as React from 'react';
import { Field } from 'redux-form';

import { FormInlineGrid } from '@inqool/uas-web-core/es/components/controls/InlineGrid';

import * as T from '@components/form/InlineGrid/_inlineGridTypes';

const InlineGrid: React.SFC<T.OutterProps & T.InnerProps> = ({ dialogProps = {}, ...props }) => {
  return (
    <FormInlineGrid
      dialogProps={{
        contentStyle: { minWidth: '90vw', transform: 'none' },
        bodyStyle: { overflowY: 'auto', maxHeight: '90vh' },
        autoDetectWindowHeight: false,
        ...dialogProps
      }}
      {...props}
    />
  );
};

export default InlineGrid;

export class InlineGridField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/InlineGrid/InlineGrid.tsx